import ServiceError from './ServiceError';

class ServiceNotFound extends ServiceError {
  constructor(error, message = 'Resource not found') {
    super(error, message);
  }
}

export default ServiceNotFound;
